import React from "react";
import { Button } from "primereact/button";
import { Link, useNavigate, useLocation } from "react-router-dom";

const AccessDeniedPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/";

  const handleBack = () => {
    navigate(from);
  };

  return (
    <div className="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
      <div className="flex flex-column align-items-center justify-content-center">
        <Link to="/app/homepage" className="flex align-items-center">
          <img src="/images/logoosbuk.png" alt="Sakai logo" className="mb-5 w-10rem flex-shrink-0" />
        </Link>
        <div
          style={{
            borderRadius: "56px",
            padding: "0.3rem",
            background: "linear-gradient(180deg, rgba(247, 149, 48, 0.4) 10%, rgba(247, 149, 48, 0) 30%)"
          }}
        >
          <div
            className="w-full surface-card py-8 px-5 sm:px-8 flex flex-column align-items-center"
            style={{ borderRadius: "53px" }}
          >
            <div
              className="flex justify-content-center align-items-center bg-pink-500 border-circle"
              style={{ height: "3.2rem", width: "3.2rem" }}
            >
              <i className="pi pi-fw pi-exclamation-circle text-2xl text-white"></i>
            </div>
            <h1 className="text-900 font-bold text-5xl mb-2">{"Erişim Engellendi"}</h1>
            <div className="text-600 mb-5">
              Bu sayfaya sadece OSBUK.net hesabı ile giriş yapmış kullanıcılar erişebilir.
            </div>
            <img src="/images/asset-access.svg" alt="Error" className="mb-5" width="70%" />
            <div className="flex gap-3">
              <Button icon="pi pi-arrow-left" label="Geri Dön" text onClick={handleBack} />
              <Button icon="pi pi-home" label="Ana Sayfaya Git" text onClick={() => navigate("/")} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
